const isEmpty = value => (value ? value.toString().trim().length === 0 : true);

const trimRight = (text, charlist) =>
  isEmpty(text) ? text || "" : text.replace(new RegExp(`[${charlist}]+$`), "");

const trimLeft = (text, charlist) =>
  isEmpty(text) ? text || "" : text.replace(new RegExp(`^[${charlist}]+`), "");

const slugify = (str = "") =>
  str
    .replace(/[^a-z0-9 -]/g, "") // remove invalid chars
    .replace(/\s+/g, "-") // collapse whitespace and replace by -
    .replace(/-+/g, "-"); // collapse dashes
const removeNonDigits = text =>
  !isEmpty(text) ? text.replace(/\D/g, "") : text;

// quick and suitable for relatively short strings, because it uses intermediate array
const substringCountQuick = (text, stringToFind) =>
  text.split(stringToFind).length - 1;

// slower but suitable for very long strings, because it uses RegEx
const substringCount = (text, stringToFind) =>
  (text.match(new RegExp(stringToFind, "g")) || []).length;

const trimSafe = value =>
  isEmpty(value) ? value || "" : value.toString().trim();

const toLowerCaseSafe = value =>
  isEmpty(value) ? value || "" : value.toString().toLowerCase();

const toUpperCaseSafe = value =>
  isEmpty(value) ? value || "" : value.toString().toUpperCase();

const isValidIndex = (index, length) => index >= 0 && index < length;

const getBooleanValue = value => (value ? Boolean(value) : false);

const getNumericValue = value => (value ? Number(value) : 0);

const isArray = array => array && Array.isArray(array);

const itemCount = array => (isArray(array) ? array.length : 0);

const removeEmptyValues = array =>
  isArray(array)
    ? array.filter(function(el) {
        return el;
      }) // remove empty values: "", null, undefined, and 0
    : [];

const splitSafe = value =>
  isEmpty(value) ? [] : removeEmptyValues(value.split(" "));

const isObjectValid = obj => typeof obj === "object" && obj !== null;

const isDevelopment = process.env.NODE_ENV.toLowerCase() === "development";

const consoleLog = (message, params) => {
  if (isDevelopment) {
    console.log(`${new Date().toISOString()} ${message}`, params || "");
  }
};

const isTodayOrBefore = value => {
  if (isEmpty(value)) {
    return false;
  }

  let dateValue = new Date(value);

  let currentDate = new Date();

  return dateValue <= currentDate;
};

/**
 * Ensure Valid Date (In the case that date is null/undefined)
 * @param {Date} date
 * @returns {Date|*}
 */
const ensureValidDate = date => (isEmpty(date) ? new Date() : date);

/**
 * get Input Date (ISO String Data)
 * @param {Date} date
 * @returns {string|undefined}
 */
const getInputDate = date => {
  if (!date) {
    return undefined;
  }
  try {
    const isoDate = new Date(date).toISOString();

    return isoDate.length >= 10 ? isoDate.substr(0, 10) : isoDate;
  } catch (err) {
    console.error(err);
    return undefined;
  }
};

/**
 * Is Odd Number
 * @param number
 * @returns {number}
 */
const isOddNumber = number => number % 2;

/**
 * convert Pascal case to lower case with hyphens
 * @param str
 * @return {string}
 */
const pascalToHyphen = str => {
  // Convert PascalCase to lowercase with hyphens
  return str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
};

export {
  trimRight,
  trimLeft,
  slugify,
  removeNonDigits,
  substringCountQuick,
  substringCount,
  isValidIndex,
  isEmpty,
  trimSafe,
  toLowerCaseSafe,
  toUpperCaseSafe,
  getBooleanValue,
  getNumericValue,
  itemCount,
  removeEmptyValues,
  splitSafe,
  isObjectValid,
  consoleLog,
  isTodayOrBefore,
  isArray,
  ensureValidDate,
  getInputDate,
  isOddNumber,
  pascalToHyphen
};
